import React, { useEffect, useState } from "react";
import { DatePicker, Radio, Input, Checkbox } from "antd";
import { TextField, InputLabel, MenuItem } from "@mui/material";
import { FaAngleDown } from "react-icons/fa";
import { FaAngleUp } from "react-icons/fa6";
import RichTextEditor from "react-rte";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaFileDownload } from "react-icons/fa";
const { RangePicker } = DatePicker;
const { TextArea } = Input;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#358c97",
    color: theme.palette.common.white,
    fontSize: "0.7rem",
    padding: "2vh 0.5vh",
    fontWeight: "600",
    lineHeight: "normal",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "0.75rem",
    padding: "1.5vh",
    fontWeight: "700",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
  },
}));

const UserReport = () => {
  const [value, setValue] = useState(1);
  const [colaups, setcolaups] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filter_data, setfilter_data] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    let listimg_restaurants = [];
    if (search !== "") {
      listimg_restaurants = listimg_restaurants.filter((user) => {
        return user.mobile.toLowerCase().match(search.toLowerCase());
      });
    }
    setfilter_data([...listimg_restaurants]);
  }, [search]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [textvalue, setTextValue] = useState(RichTextEditor.createEmptyValue());
  const disableFutureDates = (current) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return current && current.toDate() > today;
  };

  const onChange = (e) => {
    setValue(e.target.value);
  };

  const onTextChange = (value) => {
    setTextValue(value);
  };

  const getHTML = () => {
    return textvalue.toString("html");
  };

  const input_lable_style = {
    color: "#1a1a1a",
    fontSize: "0.65rem",
    fontWeight: "800",
    marginBottom: "0.5vh",
    textTransform: "uppercase",
  };
  return (
    <>
      <div className="user_report_filter_box">
        <div className="main_user_filer_box">
          <div className="user_rp_input_box_container">
            <InputLabel sx={input_lable_style} htmlFor="custom-input">
              Search
            </InputLabel>
            <TextField
              id="custom-input"
              placeholder="Search by Id/Email/Name/Phone Number"
              variant="outlined"
              autocomplete="off"
              size="small"
              className="user_report_input"
            />
          </div>
          <div className="user_rp_input_box_container">
            <InputLabel sx={input_lable_style} htmlFor="custom-input">
              Select Date
            </InputLabel>
            <RangePicker
              disabledDate={disableFutureDates}
              className="user_report_input"
            />
          </div>
          <div className="usr_rp_btn">Downlode CVS</div>
          {/* <div className="usr_rp_btn">Reset</div> */}
        </div>
      </div>

      <div className="user_notif_main_box">
        <div className="send_notif_box" onClick={() => setcolaups(!colaups)}>
          <span className="send_notif_title">
            Send Notification/Email to Users
          </span>
          <span className="send_notif_title">
            {!colaups ? <FaAngleDown /> : <FaAngleUp />}
          </span>
        </div>
        {colaups && (
          <>
            <div className="coloaup_box">
              <div className="notif_radio">
                <Radio.Group
                  className="radio_box"
                  onChange={onChange}
                  value={value}
                >
                  <Radio value={1}>SEND NOTIFICATION</Radio>
                  <Radio value={2}>SEND AS EMAIL </Radio>
                </Radio.Group>
              </div>
              {value === 1 ? (
                <>
                  <div className="text_area_container">
                    <div className="text_area_input">
                      <TextArea
                        rows={4}
                        placeholder="Enter Notification Content"
                        className="text_area_input_box"
                      />
                    </div>
                  </div>
                  <div className="notif_btn_box">
                    <div className="map_view_btn">SAVE</div>
                  </div>
                </>
              ) : (
                <>
                  <div className="nofic_subject_box">
                    <span>Subject :</span>
                    <TextField
                      id="custom-input"
                      placeholder="Search by Id/Email/Name/Phone Number"
                      variant="outlined"
                      autocomplete="off"
                      size="small"
                      className="notif_subject_input"
                    />
                  </div>
                  <div className="text_area_container">
                    <div className="text_area_input">
                      <RichTextEditor
                        className="text_area_input_box"
                        value={textvalue}
                        onChange={onTextChange}
                        editorStyle={{ minHeight: "25vh" }}
                      />
                    </div>
                  </div>
                  <div className="notif_btn_box">
                    <div className="map_view_btn">SAVE</div>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>

      <div className="margin_top_list">
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer component={Paper} className="customScrollbar">
            <Table
              sx={{
                minWidth: 1000,
                boxShadow:
                  "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
              }}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    <Checkbox className="custom-checkbox" />
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    ID
                  </StyledTableCell>

                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    NAME
                  </StyledTableCell>

                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    EMAIL
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    PHONE
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    REGISTERED ON
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    TOTAL ORDERS
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* {filter_data
                  .slice(page * rowsPerPage, (page + 1) * rowsPerPage)
                  .map((row, index) => ( */}
                <StyledTableRow
                //   key={index}
                //   sx={{
                //     backgroundColor: index % 2 === 0 ? "#cccccc" : "white",
                //   }}
                >
                  <StyledTableCell
                    component="th"
                    scope="row"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                      textTransform: "uppercase",
                    }}
                    width={20}
                    align="center"
                  >
                    <Checkbox className="custom-checkbox" />
                  </StyledTableCell>
                  <StyledTableCell
                    component="th"
                    scope="row"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                      textTransform: "uppercase",
                    }}
                    width={50}
                    align="center"
                  >
                    134556
                  </StyledTableCell>

                  <StyledTableCell
                    component="th"
                    scope="row"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                    width={130}
                    align="center"
                  >
                    <Link
                      //   to="/admin/restaurant-info"
                      style={{
                        color: "#358c97",
                      }}
                    >
                      Nalla manoj
                    </Link>
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                    width={120}
                  >
                    manoj@gmail.com
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                    width={100}
                  >
                    8328059954
                  </StyledTableCell>
                  <StyledTableCell
                    width={80}
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    May 11,2024
                  </StyledTableCell>
                  <StyledTableCell
                    width={50}
                    align="center"
                    sx={{
                      boxShadow:
                        "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 0.5px 0.5px",
                    }}
                  >
                    10
                  </StyledTableCell>
                </StyledTableRow>
                {/* ))} */}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={filter_data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    </>
  );
};

export default UserReport;
